import { customerData } from '../../utilities/CustomerData'

import refundAmountIcon from '../../assets/ApplicationIcons/estimateRefundIcon.png'
import refundStageIcon from '../../assets/DashboardIcons/DashboardTopBarIcons/stageIcon.png'
import lastModifiedIcon from '../../assets/DashboardIcons/DashboardTopBarIcons/lastModifiedIcon.png'

export default function DashboardTopBar() {
  return (
    <div className='lg:w-full w-11/12 flex max-sm:flex-col flex-row items-stretch justify-between max-sm:gap-5'>
      {customerData.customerLeadData.leadType !== 'Leads' ? (
        <div className='shadow-full rounded-xl p-2 max-sm:w-full w-[32%] bg-white flex flex-col'>
          <div className='absolute w-12 h-12 flex items-center justify-center rounded-full bg-secondaryColor object-contain'>
            <img 
              className='w-8 h-8' 
              src={refundAmountIcon} 
              alt='Estimate Icon' 
            />
          </div>
          <p className='text-sm mb-5 text-center font-bold mt-6'>Refund Amount</p>
          <p className='text-gray-600 text-center mb-5 font-bold text-2xl'>${customerData.customerLeadData.leadAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: customerData.customerLeadData.leadAmount % 1 !== 0 ? 2 : 0})}</p>
        </div>
      ) : (
        <div className='shadow-full rounded-xl p-2 max-sm:w-full w-[32%] bg-white flex flex-col'>
          <div className='absolute w-12 h-12 flex items-center justify-center rounded-full bg-secondaryColor object-contain'>
            <img 
              className='w-8 h-8' 
              src={refundAmountIcon} 
              alt='Estimate Icon' 
            />
          </div>
          <p className='text-sm mb-5 text-center font-bold mt-6'>Estimated Refund Amount</p>
          <p className='text-gray-600 text-center mb-5 font-bold text-2xl'>${customerData.customerLeadData.leadEstimateRefund.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: customerData.customerLeadData.leadAmount % 1 !== 0 ? 2 : 0})}</p>
        </div>
      )}
      <div className='shadow-full rounded-xl p-2 max-sm:w-full w-[32%] bg-white flex flex-col'>
        <img className='absolute w-10 h-10' src={refundStageIcon} alt='refundStageIcon' />
        <p className='text-md mb-5 text-center font-bold mt-6'>Refund Stage</p>
        <p className='text-gray-600 text-center mb-5 font-bold text-xl'>{customerData.customerStageHistory.find(customerStage => customerStage.currentStage === true).customerStageName}</p>
      </div>
      <div className='shadow-full rounded-xl p-2 max-sm:w-full w-[32%] bg-white flex flex-col'>
        <img className='absolute w-10 h-10' src={lastModifiedIcon} alt='lastModifiedIcon' />
        <p className='text-lg mb-5 text-center font-bold mt-6'>Last Modified</p>
        <p className='text-gray-600 text-center mb-5 font-bold text-xl'>{customerData.customerLeadData.leadModifiedAt.toDateString()}</p>
      </div>
    </div>
  )
}